import template from './checkboxes.html';
import './checkboxes.less';

const CheckboxesComponent = {
  bindings: {
    hide: '<', // used if the checkbox should be hidden. If hidden the unchecked state will never show.
    showWith: '<' // what model key to use to determine when the checkbox should be unhidden
  },
  template
};

export default CheckboxesComponent;



// WEBPACK FOOTER //
// ./src/components/search-form/checkboxes/checkboxes.component.js